<template>
    <div class="image-control field">
        <label class="label">Images</label>
        <div class="is-clearfix">
            <div class="is-pulled-left">
                <div v-for="image in selectedImages" class="selected-image is-128x128-max is-pulled-left">
                    <router-link :to="{name: 'image', params:{id:image.id}}" v-if="!selecting">
                        <img :src="image.thumbnail_path">
                    </router-link>
                    <img v-if="selecting" :src="image.thumbnail_path">
                    <a v-if="selecting" class="delete" @click="removeImage(image)"></a>
                </div>
                <div class="images-control is-pulled-left">
                    <div v-if="!selecting">
                        <span v-if="selectedImages.length === 0">
                            <a @click="selecting = true">Add images</a>
                        </span>
                        <span v-else>
                            <a @click="selecting = true">Edit images</a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="selecting">
            <br/>
            <a class="button is-primary" @click="save()">Save Selection</a>
            &nbsp;
            <a class="button" @click="selecting = false">Cancel</a>
            <br/>
            <br/>
            <label class="label" v-if="">Select your image(s):</label>
            <input type="text" class="input is-inline" placeholder="Type to search..." v-model="imgSearch">
            <br/>
            <br/>
        </div>
        <transition name="grow">
            <div class="image-list" v-if="selecting">
                <div class="image-tile"
                     v-for="img in filteredImages"
                     v-if="selectedImages.indexOf(img) === -1"
                     @click="selectImage(img)">
                    <div class="level" style="height: 50px">
                        <div class="level-left">
                            <div class="level-item">
                                <img :src="img.thumbnail_path" style="max-width: 50px">
                            </div>
                            <div class="level-item image-description">
                                {{ img.name }}.{{ img.extension }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<style lang="scss" rel="stylesheet/scss">
    .selected-image {
        user-select: none;
        img {
            display: block;
            margin: 0 auto;
        }
        position: relative;
        .delete {
            position: absolute;
            top: 0.25rem;
            left: 0.25rem;
        }
    }

    .images-control {
        padding: 0.5rem;
    }
</style>

<script>
    import {mapGetters} from "vuex"
    import {UPDATE_IMAGEABLES} from "../../store/mutation-types"
    export default {
        props: {
            imageableId: {type: [Number], default: null},
            imageableType: {type: [String], default: 'Product'},
        },
        mounted() {
            /**
             * TODO
             * VUEX ACTION FOR IMAGEABLES
             * CONTROLLERS FOR IMAGES
             * (IMAGE UPLOADS WHILE YOU'RE AT IT)
             */
            let imageables = this.imageables.filter(imageable => {
                return imageable.imageable_type === this.imageableType && imageable.imageable_id === this.imageableId
            })
            let image_ids  = []
            for (let imageable in imageables) {
                image_ids.push(imageables[imageable].image_id)
            }

            this.selectedImages = this.images.filter(image => image_ids.indexOf(image.id) !== -1)
        },
        data() {
            return {
                selectedImages: [],
                selecting: false,
                imgSearch: '',
            }
        },
        computed: {
            ...mapGetters(['images', 'imageables']),
            filteredImages() {
                return this.imgSearch.length > 0
                    ? this.images.filter(img => img.name.toLowerCase().indexOf(this.imgSearch.toLowerCase()) !== -1)
                    : this.images;
            }
        },
        methods: {
            selectImage(image) {
                this.selectedImages.push(image);
            },
            removeImage(image) {
                this.selectedImages.splice(this.selectedImages.indexOf(image), 1)
            },
            clearImages() {
                this.selectedImages = [];
                this.save()
            },
            save() {
                this.$store.dispatch(UPDATE_IMAGEABLES, {
                    imageable_id: this.imageableId,
                    imageable_type: this.imageableType,
                    images: this.selectedImages
                }).then(data => {
                    this.selecting = false
                })
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ImageableControl.vue?42cd467c